import React from 'react';
import ContactSettingRow from 'flow/components/contact-card/contact-fields/ContactSettingRow';
import Toggle from 'flow/components/ui-components/Toggle';
import usePriorityCalls from 'flow/hooks/usePriorityCalls';
import { TypedMap } from 'flow/types/TypedMap';
import { Contact, ContactFull } from 'flow/types/Contact';

interface Props {
    contact: TypedMap<Contact> | TypedMap<ContactFull>;
    className?: string;
}

const PriorityCallsListItem = ({ contact, className }: Props) => {
    const {
        visible,
        prioritised,
        setByAdmin,
        loading,
        title,
        description,
        onChange,
    } = usePriorityCalls(contact);

    if (!visible) {
        return null;
    }

    return (
        <ContactSettingRow
            title={title}
            hint={description}
            className={className}
        >
            <Toggle
                onChange={onChange}
                value={prioritised}
                text={title}
                ariaDisabled={setByAdmin}
                loading={loading}
            />
        </ContactSettingRow>
    );
};

export default PriorityCallsListItem;
